import './FlyToCart.css';
import { createContainer } from 'unstated-next';

export const FlyToCartContainer = createContainer(() => {
	return {
		flyToCart() {
			const targetElements = document.getElementsByClassName('cart-button');
			for (let i = 0; i < targetElements.length; i++) {
				const targetElement = targetElements[i];

				targetElement.classList.add('flashy');

				targetElement.addEventListener(
					'animationend',
					() => {
						targetElement.classList.remove('flashy');
					},
					{ once: true }
				);
			}
		},
	};
});
